import * as React from "react"

import { cn } from "@/lib/utils"

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  variant?: "default" | "atrium" | "white"
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, variant = "white", ...props }, ref) => {
    return (
      <textarea
        className={cn(
          // Base shape only; per-variant styles below own bg/text/border.
          "flex min-h-[80px] w-full rounded-md border border-input bg-white px-3 py-2 text-sm ring-offset-background placeholder:text-meta focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 transition-all duration-150",
          variant === "atrium" && "bg-atrium-inner text-white text-xs placeholder:text-meta border-atrium-border focus-visible:border-atrium-border-dark px-4 pr-12 outline-none",
          // The "white" variant is the default everywhere (FieldRow in
          // brand-editors, etc.). Used to be hardcoded bg-white with no
          // dark variant — Mission/Vision/Description came out bright
          // white on the dark page (Stephen flagged 2026-05-12). Mirror
          // the Input "default" variant's dark pairing from
          // components/ui/input.tsx so they look consistent: dark
          // background swaps to bg-atrium-inner, hover swaps to
          // bg-atrium-content, focus keeps bg-atrium-inner with the
          // accent ring.
          variant === "white" && "min-h-[80px] w-full rounded-lg border-atrium-border bg-white px-4 py-2 text-sm text-atrium-black placeholder:text-atrium-black/40 ring-offset-background outline-none ring-0 focus-visible:ring-2 focus-visible:ring-accent-600 focus-visible:ring-offset-0 focus-visible:border-accent-600 hover:border-atrium-black/20 hover:bg-atrium-content focus-visible:bg-white dark:bg-atrium-inner dark:hover:border-atrium-border-dark dark:hover:bg-atrium-content dark:focus-visible:bg-atrium-inner dark:focus-visible:ring-offset-atrium-background",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Textarea.displayName = "Textarea"

export { Textarea } 